import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-12 items-center justify-center rounded-xl bg-gray-50/80 dark:bg-gray-800/80 p-1.5 w-full backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-lg px-4 py-2.5 text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 relative overflow-hidden",
      // Inactive state
      "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100",
      "hover:bg-white/60 dark:hover:bg-gray-700/60",
      "shadow-sm hover:shadow-md",
      // Active state - beautiful brand gradient
      "data-[state=active]:bg-gradient-to-br data-[state=active]:from-brandPurple data-[state=active]:to-brandBlue dark:data-[state=active]:from-[#622bfe] dark:data-[state=active]:to-[#283dae]",
      "data-[state=active]:text-white data-[state=active]:shadow-lg data-[state=active]:shadow-brandPurple/25 dark:data-[state=active]:shadow-[#622bfe]/25",
      "data-[state=active]:ring-2 data-[state=active]:ring-white/20 dark:data-[state=active]:ring-slate-800/40",
      // Focus styles
      "dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-4 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
